<template>
	<div class="teacher-detail-m-skeleton" aria-hidden="true">
		<section class="teacher-detail-m-skeleton__profile">
			<span class="teacher-detail-m-skeleton__avatar"></span>
			<span class="teacher-detail-m-skeleton__line teacher-detail-m-skeleton__line--name"></span>
			<div class="teacher-detail-m-skeleton__tags">
				<span v-for="tag in 3" :key="tag"></span>
			</div>
			<span class="teacher-detail-m-skeleton__line teacher-detail-m-skeleton__line--intro"></span>
		</section>
		<section class="teacher-detail-m-skeleton__content">
			<div class="teacher-detail-m-skeleton__tabs">
				<span v-for="tab in 3" :key="tab"></span>
			</div>
			<div v-for="card in 3" :key="card" class="teacher-detail-m-skeleton__card">
				<span class="teacher-detail-m-skeleton__cover"></span>
				<div class="teacher-detail-m-skeleton__card-main">
					<span
						class="teacher-detail-m-skeleton__line teacher-detail-m-skeleton__line--wide"
					></span>
					<span
						class="teacher-detail-m-skeleton__line teacher-detail-m-skeleton__line--short"
					></span>
				</div>
			</div>
		</section>
	</div>
</template>

<style lang="scss" scoped>
.teacher-detail-m-skeleton {
	padding: 28px 30px 80px;

	&__profile {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 32px 28px;
		border: 1px solid #eeeeee;
		border-radius: 16px;
	}

	&__content {
		margin-top: 32px;
	}

	&__avatar,
	&__line,
	&__tags span,
	&__tabs span,
	&__cover {
		display: block;
		background: linear-gradient(90deg, #f1f1f1 25%, #fafafa 40%, #f1f1f1 60%);
		background-size: 300% 100%;
		animation: teacher-detail-m-shimmer 1.4s ease-in-out infinite;
	}

	&__avatar {
		width: 160px;
		height: 160px;
		border-radius: 50%;
	}

	&__line {
		height: 24px;
		border-radius: 6px;

		&--name {
			width: 220px;
			height: 36px;
			margin-top: 24px;
		}

		&--intro {
			width: 86%;
			margin-top: 26px;
		}

		&--wide {
			width: 78%;
		}
		&--short {
			width: 48%;
			margin-top: 18px;
		}
	}

	&__tags,
	&__tabs {
		display: flex;
		gap: 16px;
	}

	&__tags {
		margin-top: 20px;

		span {
			width: 100px;
			height: 34px;
			border-radius: 8px;
		}
	}

	&__tabs {
		margin-bottom: 28px;

		span {
			width: 150px;
			height: 48px;
			border-radius: 8px;
		}
	}

	&__card {
		display: flex;
		gap: 22px;
		padding: 20px;
		margin-bottom: 20px;
		border: 1px solid #eeeeee;
		border-radius: 14px;
	}

	&__cover {
		flex: 0 0 auto;
		width: 190px;
		height: 150px;
		border-radius: 10px;
	}

	&__card-main {
		flex: 1;
		padding-top: 18px;
	}
}

@keyframes teacher-detail-m-shimmer {
	0% {
		background-position: 100% 0;
	}
	100% {
		background-position: 0 0;
	}
}

@media (prefers-reduced-motion: reduce) {
	.teacher-detail-m-skeleton
		:is(
			.teacher-detail-m-skeleton__avatar,
			.teacher-detail-m-skeleton__line,
			.teacher-detail-m-skeleton__tags span,
			.teacher-detail-m-skeleton__tabs span,
			.teacher-detail-m-skeleton__cover
		) {
		animation: none;
	}
}
</style>
